<script setup lang="ts">
const { t } = useI18n();

const props = defineProps<{
    modelValue: boolean | undefined;
    trueLabel?: string;
    falseLabel?: string;
}>();

const emit = defineEmits<{
    'update:modelValue': [v: boolean]
}>();

const options = computed(() => ([
    { label: props.trueLabel || t('common.actions.yes'), value: true },
    { label: props.falseLabel || t('common.actions.no'), value: false }
]));
</script>

<template>
    <VLSelect
        :options="options"
        option-label="label"
        option-value="value"
        :model-value="modelValue"
        v-bind="$attrs"
        @update:model-value="(v: boolean) => emit('update:modelValue', v as boolean)"
    />
</template>
